(() => {
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const bindEventDate = (picker) => {
    if (picker.dataset.eventDateBound === 'true') return;

    const trigger = picker.querySelector('.mollyevers-event-date-trigger');
    const calendar = picker.querySelector('[data-date-calendar]');
    const label = picker.querySelector('[data-date-label]');
    const input = picker.querySelector('[data-date-value]');
    const monthLabel = picker.querySelector('[data-date-month]');
    const daysRoot = picker.querySelector('[data-date-days]');
    if (!trigger || !calendar || !input || !monthLabel || !daysRoot) return;

    const minimumDays = Number.parseInt(picker.dataset.eventDateMinDays, 10) || 0;
    const minimumDate = new Date();
    minimumDate.setHours(12, 0, 0, 0);
    minimumDate.setDate(minimumDate.getDate() + minimumDays);
    const minimumValue = formatDate(minimumDate);
    input.min = minimumValue;
    let viewDate = new Date(minimumDate.getFullYear(), minimumDate.getMonth(), 1, 12);
    let selectedDate = null;

    const displayDate = (date) => `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
    const sameDay = (a, b) => a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

    const close = () => {
      calendar.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    const selectDate = (date) => {
      selectedDate = date;
      input.value = date ? formatDate(date) : '';
      label.textContent = date ? displayDate(date) : 'MM/DD/YYYY';
      close();
    };

    const render = () => {
      monthLabel.textContent = viewDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      daysRoot.replaceChildren();
      const year = viewDate.getFullYear();
      const month = viewDate.getMonth();
      const firstWeekday = new Date(year, month, 1, 12).getDay();
      const daysInMonth = new Date(year, month + 1, 0, 12).getDate();
      for (let blank = 0; blank < firstWeekday; blank += 1) daysRoot.append(document.createElement('span'));
      for (let day = 1; day <= daysInMonth; day += 1) {
        const date = new Date(year, month, day, 12);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(day);
        button.setAttribute('role', 'gridcell');
        button.disabled = date < minimumDate;
        if (sameDay(date, selectedDate)) button.setAttribute('aria-current', 'date');
        button.addEventListener('click', () => selectDate(date));
        daysRoot.append(button);
      }
    };

    const validate = () => {
      if (input.value && input.value < minimumValue) {
        input.setCustomValidity(`Please choose a date on or after ${minimumValue}.`);
        return false;
      }

      input.setCustomValidity('');
      return true;
    };

    trigger.addEventListener('click', () => {
      if (calendar.hidden) {
        calendar.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        render();
      } else {
        close();
      }
    });
    picker.querySelector('[data-date-previous]').addEventListener('click', () => { viewDate.setMonth(viewDate.getMonth() - 1); render(); });
    picker.querySelector('[data-date-next]').addEventListener('click', () => { viewDate.setMonth(viewDate.getMonth() + 1); render(); });
    picker.querySelector('[data-date-clear]').addEventListener('click', () => selectDate(null));
    picker.querySelector('[data-date-today]').addEventListener('click', () => {
      const today = new Date();
      today.setHours(12, 0, 0, 0);
      if (today >= minimumDate) selectDate(today);
      else { viewDate = new Date(minimumDate.getFullYear(), minimumDate.getMonth(), 1, 12); render(); }
    });
    document.addEventListener('click', (event) => { if (!picker.contains(event.target)) close(); });

    const formId = input.getAttribute('form');
    const form = formId ? document.getElementById(formId) : input.closest('form');

    if (form) {
      form.addEventListener(
        'submit',
        (event) => {
          if (validate()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        },
        true
      );
    }

    picker.dataset.eventDateBound = 'true';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-event-date-picker]').forEach(bindEventDate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
